import { PUPPY_COLLEGE_ENTITLEMENT } from './constants';

export function hasPuppyCollegeAccess(entitlements) {
  if (!entitlements) return false;

  return entitlements.includes(PUPPY_COLLEGE_ENTITLEMENT);
}
